/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as roomActions from '../actions/roomActions';

export function useNotaryTasks(roomId: string) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  async function dispatchNotaryTasks() {
    try {
      await roomActions.fetchRoomNotaryTasks(roomId)(dispatch);
    } catch {
      roomActions.setRoomError({ hasError: true, message: 'Please try again later' });
    } finally {
      setIsLoading(false);
    }
  }

  return { isLoading, dispatchNotaryTasks };
}
